import React, { useEffect, useState } from 'react';
import { launchPriceEndsAt } from '../data/landing';
type Remaining = {
  expired: boolean;
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
};
function getRemaining(target: number): Remaining {
  const diff = target - Date.now();
  if (diff <= 0) {
    return {
      expired: true,
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    };
  }
  const totalSeconds = Math.floor(diff / 1000);
  return {
    expired: false,
    days: Math.floor(totalSeconds / 86400),
    hours: Math.floor(totalSeconds % 86400 / 3600),
    minutes: Math.floor(totalSeconds % 3600 / 60),
    seconds: totalSeconds % 60
  };
}
const pad = (value: number) => String(value).padStart(2, '0');
export function LaunchCountdown() {
  const target = new Date(launchPriceEndsAt).getTime();
  const [remaining, setRemaining] = useState<Remaining>(() => getRemaining(target));
  useEffect(() => {
    if (remaining.expired) return;
    const id = window.setInterval(() => {
      const next = getRemaining(target);
      setRemaining(next);
      if (next.expired) window.clearInterval(id);
    }, 1000);
    return () => window.clearInterval(id);
  }, [target, remaining.expired]);
  if (remaining.expired) {
    return <div className="rounded-2xl bg-cream px-4 py-3 text-center" data-id="element-70" data-mp="3v9wn1ukzhj48">
        <p className="font-sans text-[13px] font-semibold text-petrol" data-id="element-71" data-mp="3w0f6uamtym7">
          El precio de lanzamiento finalizó.
        </p>
        <p className="mt-1 font-sans text-xs text-petrol-muted" data-id="element-72" data-mp="8ubp150xg94f">
          Consultanos por el precio vigente antes de comprar.
        </p>
      </div>;
  }
  const units = [{
    label: 'días',
    value: remaining.days
  }, {
    label: 'hs',
    value: remaining.hours
  }, {
    label: 'min',
    value: remaining.minutes
  }, {
    label: 'seg',
    value: remaining.seconds
  }];
  return <div className="rounded-2xl bg-cream px-4 py-3.5 text-center" data-id="element-73" data-mp="2jnxxu13nrc4w">
      <p className="font-sans text-[11px] font-bold uppercase tracking-[0.2em] text-gold-dark" data-id="element-74" data-mp="2jpsntttsdufu">
        Precio de lanzamiento
      </p>
      <p className="mt-1.5 font-sans text-[13px] text-petrol-muted" data-id="element-75" data-mp="3rwn4535exg92">El precio actual termina en:</p>

      <div className="mt-2.5 flex items-start justify-center gap-1.5" role="timer" aria-live="off" data-id="element-76" data-mp="3mz3ru8s9zdjr">
        {units.map(unit => <div key={unit.label} className="min-w-[3.25rem] rounded-xl bg-white px-2 py-1.5 shadow-card" data-id="element-77" data-mp="4ua5bql0y6f0">
            <span className="block font-display text-xl font-semibold leading-none tabular-nums text-petrol" data-id="element-78" data-mp="eqn1cv41kwcx">
              {pad(unit.value)}
            </span>
            <span className="mt-1 block font-sans text-[10px] font-medium uppercase tracking-[0.12em] text-petrol-muted" data-id="element-79" data-mp="9rjur68eyi2u">
              {unit.label}
            </span>
          </div>)}
      </div>
    </div>;
}